import React, { useEffect, useRef, useState } from "react";

export const Reveal = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || !("IntersectionObserver" in window)) {
      setVisible(true);
      return undefined;
    }
    const io = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setVisible(true); io.disconnect(); }
    }, { threshold: 0.12 });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div ref={ref} className={`reveal ${visible ? "is-visible" : ""} ${className}`} style={{ transitionDelay: `${delay}ms` }}>
      {children}
    </div>
  );
};

export const SectionTitle = ({ eyebrow, title, gold, subtitle }) => (
  <Reveal className="text-center mb-14 md:mb-20">
    <p className="text-xs sm:text-sm tracking-[0.3em] uppercase text-amber-400/80 mb-4">{eyebrow}</p>
    <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold text-white mb-5">
      {title} <span className="gold-text">{gold}</span>
    </h2>
    <div className="gold-divider w-32 mx-auto mb-6" />
    {subtitle && <p className="font-elegant italic text-lg md:text-xl text-zinc-300 max-w-2xl mx-auto">{subtitle}</p>}
  </Reveal>
);
